export default function MaterialIcon({ name, variant = 'float', className = '', ...rest }) {
  const anim = variant && variant !== 'none' ? `ca-mi ca-mi--${variant}` : '';
  return (
    <span
      className={`material-icons ${anim} ${className}`.trim()}
      aria-hidden
      {...rest}
    >
      {name}
    </span>
  );
}
